import { updateDataSearch } from "actions/QuanLyGoiVay";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";


export const SearchBarDesktop = ({ onSearch }) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchGoiVay);

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateState = (field, text) => {
    dispatch(
    updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  useEffect(() => {


  }, []);
  return (
    <>
      <div
        className="search-new hidden-mobile-main show-table-main"
        style={{ marginTop: 5 }}
      >
        <div className="input-sm-new input-new-18">

          <input
            placeholder="Tên, mã gói vay"
            type="text"
            className="form-control input-sm"
            // value={dataSearch.sSearch || ""} // tránh undefined
            onChange={updateTextValue("sSearch")} // sửa lại field
          ></input>
        </div>

        <div className="input-sm-new input-new-18">
          <button
            type="submit"
            className="btn btn-info-new "
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
